export default __webpack_public_path__ + "static/media/whatsapp.51a9b4e3.svg";